import style from './style.css'
import { useState } from "preact/hooks";

const ProductDetails = ({ product, quantityChanged, showQuantity }) => {
  const [qty, setQty] = useState(0);
  const renderQuantity = () => {
    if (!product || !product.max_quantity) return null
    
    let options = [
      (<option value={0}>None</option>)
    ]
    for (let i=1;i<=product.max_quantity;i++){
      const selected = qty === i ? 'selected' :'';
      options.push((
        <option value={i} selected={selected}>
          {i} x ${product.price_per_unit.toFixed(2)}
        </option>)
      )
    }
    
    return options
  }

  const updateQuantity = (e) => {
    const newQty = parseInt(e.target.value);
    setQty(newQty);
    quantityChanged(product.id, {
      quantity: newQty
    })
  }

  const renderAddons = () => {
    return product.addons.map(a => (
      (<option value={a.id} disabled={a.sold_out}>{a.sold_out ? '(Sold out)' : ''} {a.name} - ${a.price_per_unit.toFixed(2)}</option>)
    ))
  }

  const addonsChanged = (e) => {
    quantityChanged(product.id, {
      addon: parseInt(e.target.value)
    })
  }

  return (
    <div class={style.profile}>
      {product && product.image_url && <img src={product.image_url} />}
			<h2>{product.name}</h2>
			<div class={style.desc}>{product.description}</div>
			<br/>
			{product.sold_out && <h2>Sold out!</h2>}
      {showQuantity && !product.sold_out &&
        <div>
          <b>Quantity</b>
          <button onClick={() => updateQuantity({target:{value: qty+1}})}>+</button>
          <select onChange={updateQuantity}>
            {renderQuantity()}
          </select>
          <button onClick={() => updateQuantity({target:{value: qty-1}})}>-</button>
        </div>
      }
      {showQuantity && !product.sold_out && product.addons.length > 0 && 
        <div class={style.FormRow}>
          <b>Options</b>
          <select onChange={addonsChanged}>
            <option>None</option>
            {renderAddons()}
          </select>
        </div>
      }
    </div>
  )
}

export default ProductDetails;